import type { NewConfirmationSelectOption } from "../types/new-confirmation.types";

const CRYPTO_STABLECOIN_NETWORK_OPTIONS: NewConfirmationSelectOption[] = [
  { label: "TRC20", value: "TRC20" },
  { label: "BEP20", value: "BEP20" },
  { label: "Polygon", value: "Polygon" },
  { label: "Solana", value: "Solana" },
  { label: "ERC20", value: "ERC20" },
];

export const PAYMENT_METHODS_BY_CURRENCY: Record<
  string,
  NewConfirmationSelectOption[]
> = {
  COP: [
    { label: "Bre-B", value: "Bre-B" },
    { label: "Nequi", value: "Nequi" },
    { label: "ACH", value: "ACH" },
    { label: "Bancolombia", value: "Bancolombia" },
  ],
  BRL: [{ label: "Pix", value: "Pix" }],
  MXN: [{ label: "SPEI", value: "SPEI" }],
  CLP: [
    { label: "Transferencia bancaria local", value: "Transferencia bancaria local" },
    { label: "Cuenta RUT", value: "Cuenta RUT" },
  ],
  PEN: [
    { label: "Transferencia bancaria interbancaria (CCI)", value: "Transferencia bancaria interbancaria (CCI)" },
    { label: "Yape", value: "Yape" },
    { label: "Plin", value: "Plin" },
  ],
  PYG: [{ label: "Transferencia bancaria local", value: "Transferencia bancaria local" }],
  UYU: [{ label: "Transferencia bancaria local", value: "Transferencia bancaria local" }],
  USD: [
    { label: "ACH", value: "ACH" },
    { label: "Wire Transfer", value: "Wire Transfer" },
    { label: "Zelle", value: "Zelle" },
    { label: "Transferencia interna bancaria", value: "Transferencia interna bancaria" },
  ],
  EUR: [
    { label: "SEPA", value: "SEPA" },
    { label: "SEPA Instant", value: "SEPA Instant" },
  ],
  HKD: [
    { label: "FPS (Faster Payment System)", value: "FPS (Faster Payment System)" },
    { label: "Transferencia bancaria local", value: "Transferencia bancaria local" },
    { label: "CHATS", value: "CHATS" },
  ],
  CNY: [
    { label: "Transferencia bancaria local", value: "Transferencia bancaria local" },
    { label: "Alipay", value: "Alipay" },
    { label: "WeChat Pay", value: "WeChat Pay" },
  ],
  CRC: [
    { label: "SINPE", value: "SINPE" },
    { label: "SINPE Móvil", value: "SINPE Móvil" },
    { label: "Transferencia bancaria local", value: "Transferencia bancaria local" },
  ],
  ARS: [
    { label: "CBU", value: "CBU" },
    { label: "CVU", value: "CVU" },
  ],
  GTQ: [
    { label: "Transferencia bancaria local", value: "Transferencia bancaria local" },
    { label: "ACH Guatemala", value: "ACH Guatemala" },
    { label: "Transferencias internas bancarias", value: "Transferencias internas bancarias" },
  ],
  USDT: CRYPTO_STABLECOIN_NETWORK_OPTIONS,
  USDC: CRYPTO_STABLECOIN_NETWORK_OPTIONS,
  BINANCE_PAY: [{ label: "BINANCE_PAY", value: "BINANCE_PAY" }],
};

export function getBankOptionsForCurrency(currencyCode: string): NewConfirmationSelectOption[] {
  if (!currencyCode) return [];
  return PAYMENT_METHODS_BY_CURRENCY[currencyCode] ?? [];
}
